import { render, staticRenderFns } from "./ModalBrand.vue?vue&type=template&id=eec346e2&scoped=true&"
import script from "./ModalBrand.vue?vue&type=script&lang=js&"
export * from "./ModalBrand.vue?vue&type=script&lang=js&"
import style0 from "./ModalBrand.vue?vue&type=style&index=0&id=eec346e2&lang=scss&scoped=true&"
import style1 from "./ModalBrand.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec346e2",
  null
  
)

export default component.exports